export default "__VITE_ASSET__df1b0312__"